//export const BASE_URL = "https://zimanb2c.citysmile.in/backend/";
 ///export const BASE_URL = "https://captainindia.anekalabs.com/backend/index.php";
// export const BASE_URL = "https://localhost/ziman-b2c/backend";
//export const BASE_URL = "http://localhost/ziman_b2c/EasyDevReact/";

// export const BASE_URL = "http://localhost/captainindia/backend/index.php";
  //   export const BASE_URL = "http://localhost/captain-india-phase-2/backend/index.php";
  // export const BASE_URL = "https://captainindia.anekalabs.com/backend/index.php";
  // export const BASE_URL = "https://captainindiatest2.anekalabs.com/backend/index.php";
//  export const BASE_URL = "https://uat.captainindia.anekalabs.com/backend/index.php";
//  export const BASE_URL = "https://sarsspl.com/dial4567/backend/index.php";
//  export const BASE_URL = "http://uat1.captainindia.anekalabs.com/backend/index.php";

// 9-12-2024 (bimmi singh)
export const BASE_URL = "https://uat.zimaxxtech.com/backend/index.php";

// 12-2-2025 (Bimmi Singh) for dial
export const BASE_URL_Dial = "https://sarsspl.com/dial4567/backend/index.php";

// // 25-12-2024 (bimmi singh)
// export const BASE_URL = "https://sarsspl.com/captainIndia/backend/index.php";